import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import UpGuardConfigListing from './UpGuardConfigListing';
import UpGuardCredentialsForm from './UpGuardCredentialsForm';

const UpGuardPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={UpGuardCredentialsForm}
        PullConfigListingView={UpGuardConfigListing}
     />
);

export default UpGuardPullAndPushView;
